import { AxiosInstance } from 'axios';

import { appConfig } from '@/configs';
import { LoginMutationArguments, LoginMutationResponse, LogoutMutationResponse } from './auth.types';

const BASE_URL = appConfig.apiURL;

export const authMutations = {
  loginMutation: (client: AxiosInstance) => async (body: LoginMutationArguments) => {
    const response = await client.post<{ data: LoginMutationResponse }>('/login', body);
    return response.data.data;
  },
  logoutMutation: (client: AxiosInstance) => async () => {
    const response = await client.post<LogoutMutationResponse>('/logout');
    return response.data;
  },
};

export const refreshTokenUrl = `${BASE_URL}/refresh-token`;
